import { Link } from "react-router-dom";

const columnLinks = [
  {
    title: "逛逛瓜田",
    links: [
      { label: "瓜田热榜", hash: "topics" },
      { label: "观点 PK", hash: "pk" },
      { label: "二创解读", hash: "remix" },
      { label: "深夜八卦", hash: "topics" },
    ],
  },
  {
    title: "关于本站",
    links: [
      { label: "吃瓜守则", hash: "rules" },
      { label: "常见问题", hash: "faq" },
      { label: "投稿通道", hash: "contact" },
      { label: "联系编辑部", hash: "contact" },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer className="w-full bg-primary-950 text-background-100">
      <div className="mx-auto w-full max-w-[1400px] px-4 py-12 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-accent-500 text-primary-950">
                <i className="ri-chat-smile-2-fill text-xl" aria-hidden="true" />
              </span>
              <span className="font-heading text-xl font-black text-background-50">吃瓜瓜田</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-background-200/80">
              一个认真吃瓜的话题社区。我们围观热点、交换观点、理性站队，也坚持不人肉、不造谣、不人身攻击。
              这里的内容均为话题讨论与虚构演绎，不指向任何真实个人。
            </p>
            <div className="mt-6 flex flex-wrap items-center gap-3">
              <a
                href="mailto:editor@guatian-community.example"
                className="flex items-center gap-2 rounded-md border border-background-100/25 px-3.5 py-2 text-sm text-background-100 transition-colors hover:border-accent-400 hover:text-accent-300"
              >
                <i className="ri-mail-line text-base" aria-hidden="true" />
                editor@guatian-community.example
              </a>
            </div>
          </div>

          {columnLinks.map((column) => (
            <div key={column.title}>
              <h3 className="text-sm font-bold tracking-wide text-background-50">{column.title}</h3>
              <ul className="mt-4 space-y-3">
                {column.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={`/#${link.hash}`}
                      className="text-sm text-background-200/75 transition-colors hover:text-accent-300"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 flex flex-col gap-4 border-t border-background-100/15 pt-6 text-xs text-background-200/60 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 吃瓜瓜田 · 话题社区 · 内容均为虚构演绎，请理性吃瓜</p>
          <div className="flex flex-wrap items-center gap-4">
            <Link to="/" className="transition-colors hover:text-accent-300">
              首页
            </Link>
            <Link to="/#rules" className="transition-colors hover:text-accent-300">
              社区规范
            </Link>
            <Link to="/#faq" className="transition-colors hover:text-accent-300">
              免责说明
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}